import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { useBrand } from '../../contexts/BrandContext';
import { antwortVon, bestaetigungsErgebnis, type BestaetigungsErgebnis } from './anmeldeProblemLogik';
import { bestaetigeAnmeldeproblem } from './hilfeApi';
import { ANMELDEPROBLEM_TEXTE, anmeldeproblemBestaetigenText, anmeldeproblemDanke } from './hilfeTexte';

// Bestätigung über den Link aus der Mail (Profil-Nachbau F-21, F21-5; PF-332): Login.tsx zeigt diese Ansicht, wenn
// ?anmeldeproblem=<token> in der Adresse stand, und hat den Token schon aus der Adresse genommen. Bestätigt wird erst mit dem Klick
// auf „Anfrage bestätigen“, nie beim Laden: Vorschau-Programme in Postfächern sollen den Link nicht von selbst einlösen. Ein leerer
// Token (Wert in falscher Form) zeigt gleich den Satz zum abgelaufenen Link.
const T = ANMELDEPROBLEM_TEXTE;
type Stand = { art: 'offen' } | { art: 'sendet' } | BestaetigungsErgebnis;

export default function AnmeldeProblemBestaetigt({ token, zurAnmeldung, erneutMelden }: { token: string; zurAnmeldung: () => void; erneutMelden: () => void }) {
  const brand = useBrand();
  const [stand, setStand] = useState<Stand>(() => (token ? { art: 'offen' } : { art: 'abgelaufen' }));

  const bestaetigen = async () => {
    if (stand.art === 'sendet') return;
    setStand({ art: 'sendet' });
    try {
      setStand(bestaetigungsErgebnis(200, await bestaetigeAnmeldeproblem(token)));
    } catch (error) {
      const { status, daten } = antwortVon(error);
      setStand(bestaetigungsErgebnis(status, daten));
    }
  };

  if (stand.art === 'erfolg') {
    return <div className="login-form-wrap">
      <h1 id="auth-title">{T.bestaetigenTitel}</h1>
      <div className="login-notice success" role="status"><strong>{T.dankeTitel}</strong><span>{anmeldeproblemDanke(stand.referenz)}</span></div>
      <p className="login-access"><button type="button" className="login-recovery" onClick={zurAnmeldung}>{T.zurAnmeldung}</button></p>
    </div>;
  }
  if (stand.art === 'abgelaufen') {
    return <div className="login-form-wrap">
      <h1 id="auth-title">{T.bestaetigenTitel}</h1>
      <div className="login-notice error" role="alert"><span>{T.abgelaufen}</span></div>
      <p className="login-access"><button type="button" className="login-recovery" onClick={erneutMelden}>{T.erneutMelden}</button></p>
    </div>;
  }
  const sendet = stand.art === 'sendet';
  return <div className="login-form-wrap">
    <h1 id="auth-title">{T.bestaetigenTitel}</h1>
    <p className="login-intro">{anmeldeproblemBestaetigenText(brand.displayName)}</p>
    {stand.art === 'fehler' && <div className="login-notice error" role="alert"><span>{stand.satz}</span></div>}
    <button type="button" className="login-submit" disabled={sendet} aria-busy={sendet} onClick={() => void bestaetigen()}>
      <span>{sendet ? T.sendet : T.bestaetigen}</span>{sendet ? <span className="login-state-indicator" aria-hidden="true" /> : <ArrowRight aria-hidden="true" />}
    </button>
    <p className="login-access"><button type="button" className="login-recovery" onClick={zurAnmeldung}>{T.zurAnmeldung}</button></p>
  </div>;
}
